import { checkoutReducer as checkoutMainReducer } from './checkout-main.reducer';
import { initialState } from './initial-state-params';
export default function checkoutReducer(state = initialState, action) {
  return checkoutMainReducer(state, action);
}